export default "__VITE_ASSET__B2eMGhx6__"